import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CAPTCHA_CONFIG } from './captcha.config';
import { CaptchaConfig } from './captcha.interface';
import type { CaptchaAction } from './captcha.types';

@UntilDestroy({ className: 'CaptchaService' })
@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  private config = inject<CaptchaConfig>(CAPTCHA_CONFIG, { optional: true });
  private platformId = inject(PLATFORM_ID);
  private reCaptchaV3Service = inject(ReCaptchaV3Service);

  getCaptchaV3Token(action: CaptchaAction): Promise<string | undefined> {
    if (!isPlatformBrowser(this.platformId)) {
      // Don't execute if running on the server
      return Promise.resolve(undefined);
    }
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    style.appendChild(
      document.createTextNode(`
      .grecaptcha-badge {
        display: none;
      }`),
    );

    head.appendChild(style);

    return this.reCaptchaV3Service.executeAsPromise(
      this.config?.recaptchaV3PublicKey ?? '',
      action,
      { useGlobalDomain: true },
    );
  }
}
